mutation updateHoppermationSender($input: UpdateHoppermationSenderInput!) {
  sender: updateHoppermationSender(input: $input) {
    id
    isVerified
    isAcknowledged
    fromEmail
    name
  }
}
